
export let globals = {};

export const setGlobals = (newGlobals) => {
	globals = newGlobals;
};
